export const validateCEP = new RegExp('^[0-9]{5}-[0-9]{3}$');
